module.exports = __webpack_public_path__ + "img/insu-qa-card-loss.8e5d99bd.png";